import { render, staticRenderFns } from "./GoodsData.vue?vue&type=template&id=75465508&scoped=true&"
import script from "./GoodsData.vue?vue&type=script&lang=js&"
export * from "./GoodsData.vue?vue&type=script&lang=js&"
import style0 from "./GoodsData.vue?vue&type=style&index=0&id=75465508&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75465508",
  null
  
)

export default component.exports